export const breakpoints = {
  sm: "660px",
  md: "820px",
  lg: "1080px",
  xl: "1400px",
  "2xl": "1800px",
};
